const HeaderBussines = () => {
  return (
    <div id="headerBussines">
      <div className="boxHeader">
        <div className="idContainer">ID</div>
        <div className="dateContainer">Fecha</div>
        <div className="rfcContainer">RFC</div>
        <div className="nameContainer">Empresa</div>
        <div className="statusContainer">Estado</div>
        <div className="creditContainer">Acuerdo de pago</div>
      </div>
    </div>
  );
};

export default HeaderBussines;
